import type { ReactNode } from 'react';

export const TOAST_APPEARANCES = ['success', 'error', 'info', 'warning'] as const;

export type ToastAppearance = (typeof TOAST_APPEARANCES)[number];

/** Identifies our own container: the viewer and the editor mount theirs, with the same class, in `document.body` too. */
export const TOAST_REGION_NAME = 'app';

export const TOAST_REGION_SELECTOR = `[data-toast-region="${TOAST_REGION_NAME}"]`;

export type ToastContainerProps = {
  /** The toasts currently on screen. Injected by `<ToastProvider>`. */
  children?: ReactNode;
  /** Injected by `<ToastProvider>`. The library only uses it to toggle `pointer-events`. */
  hasToasts?: boolean;
  /** Corner the stack is pinned to. Injected by `<ToastProvider>` from its own `placement`. */
  placement?: string;
  /** Any other prop `<ToastProvider>` injects, forwarded to `DefaultToastContainer`. */
  [key: string]: unknown;
};

export type ToastProps = {
  /** Visual state of the toast; drives icon and colour. Injected by `addToast(msg, { appearance })`. */
  appearance?: ToastAppearance;
  /** The message to show. */
  children?: ReactNode;
  /** Dismisses the toast. Injected by the `<ToastProvider>` of `react-toast-notifications`. */
  onDismiss?: () => void;
  /** Any other prop `<ToastProvider>` injects, forwarded to `DefaultToast`. */
  [key: string]: unknown;
};
